import { FormProvider } from 'react-hook-form';
import { useCreateUserForm } from './hooks';
import { CreateUserFormPresentation } from './presentations';

/**
 * 利用者追加フォームのコンテナコンポーネント
 */
export const CreateUserForm: React.FC = () => {
  const {
    state: { methods, isButtonDisabled, searchAction },
    actions: { handleOnSubmit },
  } = useCreateUserForm();

  return (
    <FormProvider {...methods}>
      <CreateUserFormPresentation
        isButtonDisabled={isButtonDisabled}
        onSubmit={handleOnSubmit}
        searchAction={searchAction}
      />
    </FormProvider>
  );
};
